export default __webpack_public_path__ + "static/media/banner2.acb65030.jpg";